import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DropZone from 'react-dropzone';
import Modal from 'react-modal';
import { modalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { formatDate } from '../../utils/';
import { fetchFactSheets } from '../../actions/project_actions';
import FactSheetViewFormInfra from './FactSheetViewFormInfra';
import { MdLineStyle } from 'react-icons/lib/md';
import { fetchProjectContractDetails } from '../../actions/additional_actions';
import GMapInfrastructure from '../detail/GMapInfrastructure';
import { getEmailFromToken } from '../../actions';
class FactSheetInfra extends Component {
    constructor(props) {
        super(props);
        this.state = {
            factSheetVisible: true,
            factSheet: props.factSheet,
            isLoading: false,
            isLoadingInitial: false,
            warning: false,
            warningDescr: false,
            warningScope: false,
            warningTitle: false,
            modalVisible: false,
            charsLeftDescr: 0,
            charsLeftScope: 0,
            charsLeftTitle: 0,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showViewForm = this.showViewForm.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.errorHandler = this.errorHandler.bind(this);
        this.onDone = this.onDone.bind(this);
        this.getMemberNameByTitle = this.getMemberNameByTitle.bind(this);
        this.getConsTotalCommitedAmount = this.getConsTotalCommitedAmount.bind(this);
        this.getContractorVendor = this.getContractorVendor.bind(this);
        this.getREIServicesVendor = this.getREIServicesVendor.bind(this);
        this.getDesignConsultant = this.getDesignConsultant.bind(this);
        this.getRoleByProject = this.getRoleByProject.bind(this);

    }

    UNSAFE_componentWillMount() {
        this.props.fetchFactSheets(this.props.projectId);
        // if (this.props.contracts && this.props.contracts.length === 0) {
        //     this.props.fetchProjectContractDetails(this.props.projectId);
        // }

        //always get the latest data for the fact sheet
        this.props.fetchProjectContractDetails(this.props.projectId);
        this.setState({ isLoadingInitial: true })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ factSheet: nextProps.factSheet })
        this.setState({ isLoadingInitial: false })
        if (nextProps.factSheet.projectDescription) {
            this.setState({ charsLeftDescr: 1000 - nextProps.factSheet.projectDescription.length })
        }
        if (nextProps.factSheet.scopeOfWork) {
            this.setState({ charsLeftScope: 2000 - nextProps.factSheet.scopeOfWork.length })
        }
        if (nextProps.factSheet.factSheetTitle) {
            this.setState({ charsLeftTitle: 50 - nextProps.factSheet.factSheetTitle.length })
        }
    }
    //Only one file
    onDrop(files) {
        if (files !== undefined && files[0] !== undefined) {
            if (files[0].size < 6291456) {
                const factSheet = this.state.factSheet;
                let id = 0;
                if (factSheet.image != null) {
                    id = factSheet.image.id;
                    factSheet.image = files[0];
                    const reader = new FileReader();
                    reader.readAsDataURL(factSheet.image);
                    reader.onload = () => {
                        factSheet.image.base64 = reader.result;
                        factSheet.image.id = id;
                        factSheet.image.contentType = factSheet.image.type;
                        factSheet.image.contentLength = factSheet.image.size;
                        factSheet.image.fileName = factSheet.image.name;
                        factSheet.image.blobUrl = factSheet.image.preview;

                        this.setState({
                            factSheet
                        });
                    }
                    this.setState({ showErr: false });
                }
            }
        }
    }

    onDropRejected() {
        this.setState({ modalVisible: true });
    }

    showViewForm(toEdit) {
        this.setState({ factSheetVisible: !this.state.factSheetVisible });
    }

    handleChange(field) {
        return (e) => {
            const factSheet = this.state.factSheet;
            factSheet[field] = e.target.value;
            this.setState({ factSheet });
        };
    }

    handleChangeNumLeft(field, maxLength) {
        return (e) => {
            const factSheet = this.state.factSheet;
            factSheet[field] = e.target.value;
            this.setState({ factSheet });

            if (maxLength === 1000) {
                this.setState({
                    charsLeftDescr: maxLength - e.target.value.length
                });
            }
            else if (maxLength === 2000) {
                this.setState({
                    charsLeftScope: maxLength - e.target.value.length
                });
            }
            else if (maxLength === 50) {
                this.setState({
                    charsLeftTitle: maxLength - e.target.value.length
                });
            }
        };
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveHandler();
    }

    saveHandler() {
        const factSheet = this.state.factSheet;
        const { projectId } = this.props;
        this.setState({ isLoading: true })
        factSheet.image = {
            contentType: factSheet.image.type,
            contentLength: factSheet.image.size,
            fileName: factSheet.image.name,
            blobUrl: factSheet.image.preview,
            base64: factSheet.image.base64,
            id: factSheet.image.id,
        }
        let method = 'post';
        let url = `projects/${projectId}/factSheets`;
        return this.makePutOrPostRequest(factSheet, method, url);
    }

    makePutOrPostRequest(factSheet, method, url) {
        const { projectId } = this.props;
        factSheet.projectId = projectId;
        if (this.state.charsLeftDescr < 0) {
            this.setState({ warningDescr: true });
            this.setState({ isLoading: false })
        }

        else if (this.state.charsLeftScope < 0) {
            this.setState({ warningScope: true });
            this.setState({ isLoading: false })
        }

        else if (this.state.charsLeftTitle < 0) {
            this.setState({ warningTitle: true });
            this.setState({ isLoading: false })
        }

        else {
            withAuth(
                { method, url, data: factSheet },
                () => {
                    this.props.fetchFactSheets(projectId);
                    this.setState({ isLoading: false })
                    this.showViewForm(factSheet);
                },
                this.errorHandler
            )
        }
    }

    errorHandler(error) {
        this.setState({ isLoading: false, warning: true })
    }

    onDone() {
        this.setState({ modalVisible: false });
    }

    getMemberNameByTitle(title) {
        const { members } = this.props;
        let value = '';
        members.forEach((item) => {
            if (item.projectTitle.title === title) {
                if (value === '') {
                    value = `${item.member.firstName} ${item.member.lastName}`;
                } else {
                    value = `${value}, ${item.member.firstName} ${item.member.lastName} `
                }
            }
        })
        return value;
    }
    getConsTotalCommitedAmount() {
        const { budgets } = this.props;

        let totalCommitedAmount = 0;
        for (const element of budgets) {
            element.budget.forEach(item => {
                if (item.pObject === 'CONS') {
                    totalCommitedAmount = totalCommitedAmount + item.committedAmount
                }
            })
        }
        return totalCommitedAmount
    }


    getContractorVendor() {
        const list = this.props.contracts.filter(item => item.contractType.includes("Construction/Regular"));
        const contractorList = [];
        if (list.length > 0) {
            list.forEach((s) => {
                contractorList.push(s.contractor)
            })

        }
        return contractorList;
    }

    getREIServicesVendor() {
        const list = this.props.contracts.filter(item => item.contractType === "Professional/Requirements/Pure REI Manage/N/A" || item.contractType === "Professional/Pure REI Manage/N/A/N/A");
        const contractorList = [];
        if (list.length > 0) {
            list.forEach((s) => {
                contractorList.push(s.contractor)
            })

        }
        return contractorList;

    }

    getDesignConsultant() {
        const list = this.props.contracts.filter(item => item.contractType.includes("Design"));
        const contractorList = [];
        if (list.length > 0) {
            list.forEach((s) => {
                contractorList.push(s.contractor)
            })

        }
        return contractorList;
    }

    getRoleByProject() {

        const userEmail = getEmailFromToken();
        const list = ["Alternative Delivery Team leader", "PA – Borough Director", "PA Deputy Director", "PM/Program Administrator", "Sr. PM"]
        const { members } = this.props;
        let result = false;
        members.forEach((item) => {
            if (item.member.email.toUpperCase() === userEmail.toUpperCase()) {
                const res = list.filter(itemProject => itemProject === item.projectTitle.title);
                if (res.length > 0) {
                    result = true;
                }
            }
        })
        return result;
    }

    render() {
        const { factSheetVisible, factSheet, warning, warningDescr, warningScope, warningTitle } = this.state;
        const { info, schedule, members, projectId, budgets, contracts } = this.props;


        const designConsultant = this.getDesignConsultant();

        const reiServices = this.getREIServicesVendor();

        const contractor = this.getContractorVendor();
        const canAccess = this.getRoleByProject();
        console.log(canAccess);
        let warningMsg = '';
        if (warning)
            warningMsg = 'Save failed. Image size should be less than 6MB.';
        else if (warningDescr)
            warningMsg = 'Save failed. Please reduce Project Description field to 1000 characters.';
        else if (warningScope)
            warningMsg = 'Save failed. Please reduce Project Scope field to 2000 characters.';
        else if (warningTitle)
            warningMsg = 'Save failed. Please reduce Title field to 50 characters.';

        return (
            <div className="container">

                {this.state.isLoadingInitial ?
                    <div className="loader" /> : null}

                {this.state.modalVisible
                    && <Modal
                        isOpen={this.state.modalVisible}
                        style={modalStyle}
                        contentLabel="Upload error"
                    >
                        <h1>Maximum file upload size is 6MB</h1>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                {factSheetVisible ? null
                    : <div className="row margin-top-2 no-print">
                        <button className="btn-save margin-left-275 margin-top-075" onClick={() => this.showViewForm()}>
                            Edit</button>
                    </div>}
                {factSheetVisible && canAccess ?
                    <div>
                        <div className="row no-print">
                            <div className="col l6 m6 s12">
                                <button onClick={() => this.showViewForm()}>
                                    <span className="print-preview-link">PRINT PREVIEW</span>
                                </button>
                            </div>
                        </div>
                        <form onSubmit={this.handleSubmit}>
                            <div>
                                <div className="fact-sheet">

                                    <div className="controls text-center">
                                        <label>Title
                                            <span className="color-green"> (maximum size is 50 characters)</span>
                                            <span className="count-down-label">Characters remaining: <span className="color-green">{this.state.charsLeftTitle}</span></span>
                                        </label>
                                        <textarea name="factSheetTitle" rows="1" value={factSheet.factSheetTitle}
                                            onChange={this.handleChangeNumLeft('factSheetTitle', 50)} maxLength="50" className="height-auto text-center">
                                        </textarea>
                                    </div>

                                    <div className="row">
                                        <div className="col s12">
                                            <h4 className="text-center">{info.fmsids.join(', ')}</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col l4 m6">
                                            {/*<div className="controls padding-bottom-0">*/}
                                            {/*    <span className="label underline">Client:</span>*/}
                                            {/*</div>*/}
                                            <div className="controls">
                                                <label>Sponsor Agency</label>
                                                <input type="text" name="clientAgency" value={factSheet.clientAgency ?? ''} maxLength="50"
                                                    onChange={this.handleChange('clientAgency')} />
                                            </div>
                                            <div className="controls">
                                                <label>Commissioner</label>
                                                <input type="text" name="comissioner" value={factSheet.comissioner ?? 'Thomas Foley'} maxLength="50"
                                                    onChange={this.handleChange('comissioner')} />
                                            </div>
                                            <div className="controls">
                                                <label>First Deputy Comissioner</label>
                                                <input type="text" name="firstDeputyComissioner" value={factSheet.firstDeputyComissioner ?? 'Eric Macfarlene'} maxLength="50"
                                                    onChange={this.handleChange('firstDeputyComissioner')} />
                                            </div>
                                            <div className="controls">
                                                <label>Associate Comissioner</label>
                                                <span className="value">{this.getMemberNameByTitle('Associate commissioner ( Construction)')}</span>
                                            </div>
                                            <div className="controls">
                                                <label>Executive Director</label>
                                                <span className="value">{'Herve Carrie'}</span>

                                            </div>
                                            <div className="controls">
                                                <label>PM Director</label>
                                                <span className="value">{this.getMemberNameByTitle('PA – Borough Director')}</span>
                                            </div>
                                            <div className="controls">
                                                <label>Construction Director</label>
                                                <span className="value">{this.getMemberNameByTitle('Construction Borough Director')}</span>
                                            </div>
                                            <div className="controls">
                                                <label>Engineer In-Charge</label>
                                                <span className="value">{this.getMemberNameByTitle('DDC Construction EIC')}</span>
                                            </div>
                                            <div className="controls">
                                                <label>Resident Engineer</label>
                                                <span className="value">{this.getMemberNameByTitle('DDC Resident Engineer (Construction)')}</span>
                                            </div>

                                            <div className="controls">
                                                <label>Main Project Location</label>
                                                <textarea style={{ height: 80 }} type="text" name="address1" value={factSheet.address1} maxLength="750"
                                                    onChange={this.handleChange('address1')} />
                                            </div>



                                            <div className="controls">
                                                <label>Current Construction Cost</label>
                                                <span className="display-inline">$</span>
                                                <input type="number" name="budgetConstruction" value={factSheet.budgetConstruction ?? this.getConsTotalCommitedAmount()} step="any" min="0"
                                                    maxLength="50" onChange={this.handleChange('budgetConstruction')} />
                                            </div>
                                            <div className="controls">
                                                <label>REI Services</label>
                                                {reiServices.length > 0
                                                    ? reiServices.map((item, index) => {
                                                        return <div key={index}><span className="value span-inline">{item}</span><br /> </div>
                                                    }) : null}
                                            </div>
                                            <div className="controls">
                                                <label>Design Consultants</label>
                                                {designConsultant.length > 0
                                                    ?
                                                    designConsultant.map((item, index) => {
                                                        return <div key={index}><span className="value span-inline">{item}</span><br /> </div>
                                                    })
                                                    : null}

                                            </div>

                                            <div className="controls">
                                                <label>Contractors</label>
                                                {contractor.length > 0
                                                    ?
                                                    contractor.map((item, index) => {
                                                        return <div key={index}><span className="value span-inline">{item}</span><br /> </div>
                                                    })
                                                    : null}
                                            </div>

                                            <div className="controls">
                                                <span className="label">Contract Duration</span>
                                                {/* TBD dates */}
                                                <span className="value">Notice to Proceed: {formatDate(schedule.constructionStart.actual)} </span>
                                                <span className="value">Original Contract Completion Date:  {formatDate(schedule.constructionCompletion.constructionBaseline)}</span>
                                                <span className="value">Expected Completion Date: {formatDate(schedule.constructionCompletion.projected)}</span>
                                                <span className="value">Actual Completion Date: {formatDate(schedule.constructionCompletion.actual)}</span>
                                            </div>

                                            <div className="controls">
                                                <span className="label">Last Update By</span>
                                                <span className="value">{factSheet.modifiedUserUniqueName}</span>
                                            </div>
                                            <div className="controls">
                                                <span className="label">Last Update Date</span>
                                                <span className="value">{formatDate(factSheet.modifiedDate)}</span>
                                            </div>
                                        </div>

                                        <div className="col l8 m6">
                                            <div className="controls">
                                                <label>Title Content <span className="color-green"> (maximum size is 1000 characters)</span>
                                                    <span className="count-down-label">Characters remaining: <span className="color-green">{this.state.charsLeftDescr}</span></span>
                                                </label>
                                                <textarea name="projectDescription" rows="5" value={factSheet.projectDescription} maxLength="1000"
                                                    onChange={this.handleChangeNumLeft('projectDescription', 1000)}>
                                                </textarea>
                                            </div>
                                            <div className="controls">
                                                <label>Scope of Work  <span className="color-green"> (maximum size is 2000 characters)</span>
                                                    <span className="count-down-label">Characters remaining: <span className="color-green">{this.state.charsLeftScope}</span></span>
                                                </label>
                                                <pre className="open-sans"> <textarea name="scopeOfWork" rows="5" value={factSheet.scopeOfWork} maxLength="2000"
                                                    onChange={this.handleChangeNumLeft('scopeOfWork', 2000)}>
                                                </textarea> </pre>
                                            </div>
                                            <div className="upload-area controls">
                                                <label>Project Area </label>

                                                {factSheet.image && factSheet.image.base64 !== null ? <img src={factSheet.image.base64} alt="fact sheet" width={'950'} height={'300'} /> : null}
                                                <GMapInfrastructure projectId={projectId} />

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <button className="btn-save margin-left-275" disabled={this.state.isLoading}>{'Save'}</button>
                            </div>
                        </form>
                    </div>

                    : <FactSheetViewFormInfra
                        factSheet={factSheet}
                        schedule={schedule}
                        members={members}
                        projectId={projectId}
                        info={info}
                        budgets={budgets}
                        contracts={contracts}
                    />}

                {this.state.isLoading ? <div>
                    <div className="loader" />
                    <p className="padding-left-2 margin-left-075 label-color">Please wait</p>
                </div> : null}

                {this.state.showErr &&
                    <div>
                        <p className="padding-left-2 margin-left-075 color-orange">Please upload an image</p>
                    </div>
                }

                {warningMsg !== '' ?
                    <div>
                        <p className="padding-left-2 margin-left-075 color-orange">{warningMsg}</p>
                    </div> : null}

            </div>
        );
    }
}

FactSheetInfra.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    factSheet: PropTypes.object.isRequired,
    fetchFactSheets: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        projectId: ownProps.projectId,
        info: state.projectsStore.info,
        schedule: state.projectsStore.schedule,
        members: state.projectsStore.members,
        permissions: state.projectsStore.permissions,
        factSheet: state.projectsStore.factSheet,
        budgets: state.projectsStore.budgets,
        contracts: state.additionalProjectsStore.allCntractData,
    };
}

export default connect(mapStateToProps, {
    fetchFactSheets, fetchProjectContractDetails
})(FactSheetInfra);